import { useCallback, useEffect, useRef } from "react";
import { User, UserAccount } from "../data/types";
import SignalRServiceManager from "./SignalRServiceManager";

type UserSignalRProps = {
    onUpsertUser?: (userObj: User[]) => void;
    primaryAccount?: UserAccount;
}
export const useUserSignalR = (props: UserSignalRProps) => {
    const { onUpsertUser, primaryAccount } = props;
    const messageName = 'upsertUser';

    // Use useRef to maintain stable reference
    const onUpsertUserRef = useRef(onUpsertUser);

    useEffect(() => {
        onUpsertUserRef.current = onUpsertUser;
    }, [onUpsertUser]);

    const upsertHandler = useCallback((json: string) => {
        try {
            const theObj = JSON.parse(json);
            onUpsertUserRef.current?.(theObj);
        } catch (error) {
            console.error("Failed to parse signalR message:", error, json);
        }
    }, []); // Now stable

    useEffect(() => {
        let signalRManager: Awaited<ReturnType<typeof SignalRServiceManager.getInstance>> | null = null;

        const setupSignalR = async () => {
            if (primaryAccount) {
                signalRManager = await SignalRServiceManager.getInstance(primaryAccount);
                signalRManager?.on(messageName, upsertHandler);
            }
        };

        setupSignalR();

        return () => {
            signalRManager?.off(messageName, upsertHandler);
        };
    }, [primaryAccount, upsertHandler]);

    return null;
}